import Maybe from 'true-myth/maybe';

export const BRANDS = ['hotpads', 'zillow'] as const;
export type Brand = (typeof BRANDS)[number];

export const isBrand = (value: unknown): value is Brand => typeof value === 'string' && BRANDS.includes(value as Brand);

export const isHotpads = (value: unknown): value is 'hotpads' => value === 'hotpads';
export const isZillow = (value: unknown): value is 'zillow' => value === 'zillow';

export type HostnamePattern = {
  brand: Brand;
  patterns: Array<string>;
};

export function matchBrandForHostname(hostname: string, hostnamePatterns: Array<HostnamePattern>): Maybe<Brand> {
  const normalizedHostname = hostname.toLowerCase();
  for (const { brand, patterns } of hostnamePatterns) {
    if (patterns.some((pattern) => normalizedHostname.includes(pattern))) {
      return Maybe.just(brand);
    }
  }
  return Maybe.nothing();
}
